import Vue from 'vue'
import VueToastr from "vue-toastr"
import '@/components/ui/toastr/index.styl'

const options = {
	defaultPosition: 'toast-bottom-right',
	defaultType: 'default',
	defaultTimeout: 15000,
	defaultProgressBar: false,
}

Vue.use(VueToastr, options)

// http://s4l1h.github.io/vue-toastr/

// Exemplos de utilização
// Com titulo
// this.$toastr.Add({
// 	title: 'Facilita',
// 	msg: 'Tudo na palma da mão do corretor.'
// });
// this.$toastr.s('Mensagem de Sucesso', 'Sucesso');
// this.$toastr.e('Mensagem de Erro', 'Erro');
// this.$toastr.w('Mensagem de Atenção', 'Atenção');
// this.$toastr.i('Mensagem de Informação', 'Informação');

// Sem titulo
// this.$toastr.Add('Tudo na palma da mão do corretor.');
// this.$toastr.s('Mensagem de Sucesso');
// this.$toastr.e('Mensagem de Erro');
// this.$toastr.w('Mensagem de Atenção');
// this.$toastr.i('Mensagem de Informação');